module.exports = __webpack_public_path__ + "static/media/play.8f742c21.svg";